import { createMandatoryContext } from '@change-corgi/core/react/context';

import type { UseBreakpointStateReturn } from './hook';

export const {
	Context: StarterDashboardV2BreakpointStateContext,
	Provider: StarterDashboardV2BreakpointStateContextProvider,
	useContext: useStarterDashboardV2BreakpointState,
} = createMandatoryContext<UseBreakpointStateReturn['data']>(
	{ isMobile: false },
	{
		name: 'StarterDashboardV2BreakpointStateContext',
		processProviderProps: (props) => ({ ...props.value }),
	},
);

export type StarterDashboardV2PageBreakpointState = ReturnType<typeof useStarterDashboardV2BreakpointState>;
